import React from 'react';
import { Youtube, MessageCircle, Info, BookOpen } from 'lucide-react';

const ContactInfo = ({ onShowAbout }) => {
  return (
    <div className="w-full py-8 mt-16 border-t border-gray-200">
      <div className="flex justify-center items-center gap-8 text-gray-600 mb-6">
        <a 
          href="http://www.youtube.com/minhsao" 
          className="hover:text-red-600 transition-colors p-2"
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="YouTube Channel"
        >
          <Youtube size={28} />
        </a>
        <a 
          href="https://discord.gg/uA7KUecvaZ" 
          className="hover:text-indigo-600 transition-colors p-2"
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Discord Community"
        >
          <MessageCircle size={28} />
        </a>
        <a 
          href="https://amzn.to/3XIop0D" 
          className="hover:text-orange-500 transition-colors p-2"
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Career Books"
        >
          <BookOpen size={28} />
        </a>
        <button 
          onClick={onShowAbout}
          className="hover:text-blue-600 transition-colors p-2"
          aria-label="About"
        >
          <Info size={28} />
        </button>
      </div>
      <p className="text-center text-xs font-mono text-gray-400 mt-4">
        © {new Date().getFullYear()} ai-vs.me [ *_*] All rights reserved.
      </p>
    </div>
  );
};

export default ContactInfo;